import { Application } from '@/core/models/application';
import { GET, POST } from '@/lib/api/Methods';

export const createApplication = (data: FormData) =>
   POST<FormData, Application>('/application/create-application', data);

export const createRenewalApplication = (data: FormData) =>
   POST<FormData, Application>('/application/create-renewal-application', data);

export const getPendingApplication = () => GET<never, Application>('/application/get-pending-application');
